/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
import * as Blockly from 'blockly';
import { FieldColour } from '@blockly/field-colour';

// El plugin pinta el popup con el color del bloque; en prod el fondo es siempre blanco y no hay
// config para eso, así que se pisa showEditor_.
export class EducabotColourField extends FieldColour {
  showEditor_(e) {
    super.showEditor_(e);
    Blockly.DropDownDiv.setColour('#ffffff', '#dddddd');
  }
}

// Paleta por defecto de prod (goog SIMPLE_GRID_COLORS, 7 columnas); sin pasarla el plugin usa la suya.
export const SIMPLE_GRID_COLOURS = [
  '#ffffff', '#cccccc', '#c0c0c0', '#999999', '#666666', '#333333', '#000000',
  '#ffcccc', '#ff6666', '#ff0000', '#cc0000', '#990000', '#660000', '#330000',
  '#ffcc99', '#ff9966', '#ff9900', '#ff6600', '#cc6600', '#993300', '#663300',
  '#ffff99', '#ffff66', '#ffcc66', '#ffcc33', '#cc9933', '#996633', '#663333',
  '#ffffcc', '#ffff33', '#ffff00', '#ffcc00', '#999900', '#666600', '#333300',
  '#99ff99', '#66ff99', '#33ff33', '#33cc00', '#009900', '#006600', '#003300',
  '#99ffff', '#33ffff', '#66cccc', '#00cccc', '#339999', '#336666', '#003333',
  '#ccffff', '#66ffff', '#33ccff', '#3366ff', '#3333ff', '#000099', '#000066',
  '#ccccff', '#9999ff', '#6666cc', '#6633ff', '#6600cc', '#333399', '#330099',
  '#ffccff', '#ff99ff', '#cc66cc', '#cc33cc', '#993399', '#663366', '#330033',
];

export const SIMPLE_GRID_COLUMNS = 7;

// Medidas de celda de prod. El selector de 3 clases iguala al del plugin: con menos especificidad
// su borde gris gana. max-height: none evita el scroll que mete el tope de 300px de Blockly.
Blockly.Css.register(`
.blocklyFieldColour.blocklyDropDownContent {
  max-height: none;
}

.blocklyFieldColour .blocklyFieldGrid {
  gap: 0;
}

.blocklyFieldColour .blocklyFieldGrid .blocklyFieldGridItem {
  width: 26px;
  height: 26px;
  padding: 2px;
  margin: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-sizing: border-box;
}

.blocklyFieldColour .blocklyColourSwatch {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border: 1.6px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.blocklyFieldColour .blocklyFieldGridItemSelected .blocklyColourSwatch {
  border: 0.8px solid #000;
}
`);
